import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createElement } from 'react';
import RcSelect, { Option } from 'rc-select';
import useRemote from './useRemote';
import useExtraOptions from './useExtraOptions';
import useOptionRender from './useOptionRender';
import useSearchInMenu from './useSearchInMenu';
import useSingleSelectionOptions from './useSingleSelectionOptions';

function BaseSelect(props) {
  let selectProps = useSearchInMenu(props);
  selectProps = useExtraOptions(selectProps);
  selectProps = useSingleSelectionOptions(selectProps);
  selectProps = useOptionRender(selectProps);
  return createElement(RcSelect, selectProps);
}

function RemoteSelect(props) {
  const selectProps = useRemote(props);
  return createElement(BaseSelect, selectProps);
}

function Select({
  remote,
  remoteSearch,
  autoWidth,
  autoLoadSelectedOption,
  noBorder,
  onFetchMore,
  children,
  ...props
}) {
  const selectProps = { prefixCls: 'ge-select', ...props };
  selectProps.className = classNames(
    selectProps.className,
    (!props.value || props.value.length < 1) && `${selectProps.prefixCls}-empty`,
  );
  if (noBorder) {
    selectProps.className = classNames(selectProps.className, `${selectProps.prefixCls}-borderless`);
  }
  if (autoWidth) {
    // 尺寸是由 placeholder 和已选中项撑开的，启用搜索后 placeholder 会在用户输入搜索词时被移除，导致组件尺寸异常
    selectProps.showSearch = false;
    // 下拉菜单默认不匹配组件宽度，避免因选择框宽度过小而导致菜单内容显示不全
    selectProps.dropdownMatchSelectWidth = selectProps.dropdownMatchSelectWidth || false;
    selectProps.dropdownClassName = classNames(selectProps.dropdownClassName, `${selectProps.prefixCls}-dropdown-auto-width`);
    selectProps.className = classNames(selectProps.className, `${selectProps.prefixCls}-auto-width`);
  }
  if (remote) {
    selectProps.remoteSearch = remoteSearch;
    selectProps.onFetchMore = onFetchMore;
    selectProps.autoLoadSelectedOption = autoLoadSelectedOption;
    return createElement(RemoteSelect, selectProps, children);
  }
  return createElement(BaseSelect, selectProps, children);
}

Select.Option = Option;
Select.propTypes = {
  autoWidth: PropTypes.bool,
  autoLoadSelectedOption: PropTypes.bool,
  optionRender: PropTypes.func,
  onFetchMore: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  extraOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  className: PropTypes.string,
  remote: PropTypes.bool,
  remoteSearch: PropTypes.bool,
  searchInMenu: PropTypes.bool,
  noBorder: PropTypes.bool,
  children: PropTypes.node,
};

Select.defaultProps = {
  className: '',
  autoWidth: false,
  autoLoadSelectedOption: false,
  onFetchMore: undefined,
  optionRender: undefined,
  options: undefined,
  extraOptions: undefined,
  value: undefined,
  remote: false,
  remoteSearch: true,
  searchInMenu: false,
  noBorder: false,
  children: null,
};

export { Option };

export default Select;
